/************************************
MODULE:         SVG
WHAT IT DOES:   Loads SVG to the page, adds global classes that affect SVG
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory();
    }
    else { root.returnExports = factory(); }
}(this, function () {

    function initSprites() {
        var htmlClass = document.documentElement.getAttribute('class');
        htmlClass = htmlClass ? htmlClass : "";

        if (htmlClass.indexOf('lt-ie9') >= 0)
            return;

        //iPad with ios6 ha� bug when svg is supported but <use> doesn't work correctly
        checkUse(htmlClass);
    }

    function checkUse(htmlClass) {
        if (isIos6()) {
            document.documentElement.setAttribute('class', htmlClass + ' no-svg-use');
        }
    }

    function isIos6() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            if ((typeof v == "object") && (v instanceof Array)) {
                var ver = parseInt(v[1], 10);
                return ver <= 6;
            }

        }
        return false;
    }

    return {
        init: initSprites
    };
}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.svg.js
 ** module id = 63
 ** module chunks = 24
 **/